import { format } from 'date-fns'
import { SECOND } from '@/constant/time.ts'

interface ISessionTimes {
    endsAt: string
}

interface ISessionOwner {
    isMine: boolean
}

export const remainingMs = (endsAt: string | null | undefined, now: number): number => {
    const end = endsAt ? Date.parse(endsAt) : NaN
    return Number.isNaN(end) ? 0 : Math.max(0, end - now)
}

export const formatRemaining = (ms: number): string => {
    const totalSeconds = Number.isFinite(ms) && ms > 0 ? Math.ceil(ms / SECOND) : 0
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

export const earliestEndsAt = (sessions: ISessionTimes[]): string | null => {
    let earliest: { endsAt: string; time: number } | null = null
    for (const session of sessions) {
        const time = Date.parse(session.endsAt)
        if (Number.isNaN(time)) continue
        if (!earliest || time < earliest.time) earliest = { endsAt: session.endsAt, time }
    }
    return earliest?.endsAt ?? null
}

export const sortByEndsAt = <T extends ISessionTimes>(sessions: T[]): T[] =>
    [...sessions].sort((a, b) => Date.parse(a.endsAt) - Date.parse(b.endsAt))

export const splitByOwner = <T extends ISessionTimes & ISessionOwner>(sessions: T[]) => {
    const sorted = sortByEndsAt(sessions)
    return { mine: sorted.filter(session => session.isMine), others: sorted.filter(session => !session.isMine) }
}

const formatOr = (value: string | null | undefined, pattern: string): string => {
    const date = value ? new Date(value) : null
    return date && !Number.isNaN(date.getTime()) ? format(date, pattern) : '--:--'
}

export const formatTestClock = (value: string | null | undefined): string => formatOr(value, 'HH:mm')

export const formatTestDateTime = (value: string | null | undefined): string => formatOr(value, 'MM/dd HH:mm')
